export default __webpack_public_path__ + "static/heloisecoen-c22a6b55e251bf62c734a62740522685.jpg";